import axios from 'axios';
import syncReadingsSavedOffline from './syncReadings';
import { encodeUrlFromRouter, encodeUrlToRouter } from '@/routerUrlEncoding';

export default {
  name: 'CaptureMeterReadings2',
  components: {
    FiltersComp: require('@/employee/captureMeterReadings/filters/filters.vue').default,
    backButton: require('@/components/backButton/backButton.vue').default,
    loadingSnippet: require('@/common/loadingSnippet/loadingSnippet.vue').default,
    SearchWindow: require('@/employee/captureMeterReadings/searchModalWindow.vue').default,
    CircleSpinner: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    ReadingsListCell: require('./readingsListCell.vue').default,
    GoSearchComp: require("@/employee/captureMeterReadings/goSearch/goSearch.vue").default,
  },
  data: function () {
    return {
      bSpotBillEnabled: false,
      leavePage: true,
      cycleId: '',
      searchEnabled: true,
      showSearchDialog: false,
      loading: true,
      key: 0,
      bg: '',
      book: '',
      walk: 0,
      readingsTitle: '',
      onLine: navigator.onLine,

      readings: [],
      readingsHistory: [],
      connectionSpHeaders: [],

      filteredReadings: [],
      readingsOptions: { pageSize: 10, total: 0, page: 1, filterText: this.search },
      //readUnread states: 0 - off, 1 - unread, 2 -read
      filtersDataObj: {
        trim: { readUnread: "0", withNote: false, withAccess: false, disconnected: true, discrepancy: false },
        readings: [],
        spotBillEnabled: false,
        filteredReadings: [],
        showDialog: false,
        saveFilters: this.saveFilters
      },
      
      isPropertyOriented: false,
      editingReading: { statementNo: '' },
      spotBillingReceiptLogo: null,
    }
  },
  computed: {
    accountOrPropRef: function () {
      return this.isPropertyOriented == true ? this.editingReading.propRef : this.editingReading.account;
    },
    displayRecordNum: function () {
      return this.filteredReadings.length;
    },
    getOfflineClass: function () {
      return this.onLine ? 'transparent-strip' : 'red-strip';
    },
    readingsLength: function () {
      return this.readings ? this.readings.length : 0;
    },
    filteredReadingsLength: function () {
      return this.filtersDataObj && this.filtersDataObj.filteredReadings ? this.filtersDataObj.filteredReadings.length : 0;
    },
    backButtonUrl() {
      return this.bg && this.book ? `captureMeterReadingsBgBooks/${this.bg}/` : null;
    },
  },
  watch: {
    readingsLength: function (value) {
        this.filtersDataObj['readings'] = value > 0 ? this.readings : [];
    },
    filteredReadingsLength: function (value) {
      if (!value)
        return;
      this.filteredReadings = [...this.filtersDataObj.filteredReadings];
    },
    onLine: function (value) {
      if (value) {
        this.$oldAlertMsg(this.$t("messages.online"), 1);
        syncReadingsSavedOffline(this.$store.state.readingsLocalDB);
      }
      else {
        this.$oldAlertMsg(this.$t("messages.offline"), 1);
        this.leavePage = false;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.onLine && to.name != 'editReadings') {
      this.$root.$emit('display_ok_notification', this.$t('investigationDetail.Warning'), this.$t('messages.leavingNotPermitedAlert'));
      next(false);
    }
    else
      next();
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadings != true)
      this.$router.push('/employeeHome');

    this.bg = encodeUrlFromRouter(this.$route.params.bg);
    this.book = encodeUrlFromRouter(this.$route.params.book);
    this.walk = encodeUrlFromRouter(this.$route.params.walk);
    this.getBillingGroupName();

    this.isPropertyOriented = this.$store.state.settings.isPropertyOriented;
    this.filtersDataObj.spotBillEnabled = this.bSpotBillEnabled ?? false;
    this.onLine = navigator.onLine;

    if (navigator.onLine)
      this.getDataForOffline();
    else
      this.getDateFromOfflineDb();


  },
  mounted() {
    this.$root.$on('profile_details_updated', () => this.bSpotBillEnabled = this.$store.state.settings.spotBilling);
    this.bSpotBillEnabled = this.$store.state.settings.spotBilling;
    this.filtersDataObj['spotBillEnabled'] = this.bSpotBillEnabled;

    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    window.addEventListener('beforeunload', this.beforeunload);

    let prevSelectedRec = { ...this.$store.getters.getEditReadingActiveRecord };

    if (prevSelectedRec && prevSelectedRec.serialNo != null) {
      setTimeout(() => {
        let elem = document.getElementById(prevSelectedRec.serialNo);
        this.higlightElement(elem);
      }, 1000);
    }

    this.$store.commit('setEditReadingActiveRecord', {});
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
    window.removeEventListener('beforeunload', this.beforeunload);
  },
  methods: {
    //Go Search
    exitGoSearch(goToRecord) {
      console.log("exit", goToRecord)
    },
    goSearchNavigate(numbering) {
      let read = this.filteredReadings.filter(r => r.numbering == numbering);

      if (read != null && read.length > 0) {
        let elem = document.getElementById(read[0].serialNo);
        this.higlightElement(elem);
      }
    },


    saveFilters(trim) {
      this.filtersDataObj.trim = { ...trim };
    },
    beforeunload(event) {
      if (!this.onLine) {
        event.preventDefault();
        event.returnValue = ""
      }
    },
    higlightElement(elem) {
      if (elem == null)
        return;

      elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center", })

      setTimeout(() => {
        let loops = 100;

        let timer = setInterval(() => {
          elem.style.backgroundColor = "rgb(" + loops + "," + loops + "," + loops + ",1)";

          loops += 10;
          if (loops > 255) {
            elem.style.backgroundColor = "#FCFFFF";
            clearInterval(timer);
          }
        }, 100);
      }, 1000);       
    },
    scrollToElement(elem) {
      if (elem)
        document.getElementById(elem).scrollIntoView({ behavior: "smooth", block: "start", inline: "center", });
    },


    //Search Function
    editSearchReadingMobile(item) {
      if (!item)
        return;

      this.filteredReadings = [item];
      this.searchEnabled = false;
      this.showSearchDialog = false;
      this.trim = { readUnread: "0", withNote: false, withAccess: false, disconnected: false };
    },
    clearAdvancedSearchResults() {
      this.filteredReadings = [...this.readings];
      this.getFilterFromLocal(true);
      this.searchEnabled = true;
    },
    //Search Funtions End
    openSearch() {
      this.showSearchDialog = true;
      this.$root.$emit('update_filters_values', this.filtersDataObj.trim);
    },
    isRaised(item, isIcon = false) {      
      if (isIcon)
        return item ? 'color-white' : '';
      else
        return item ? ' md-raised background-light-gray' : '';
    },
    getOrganisationSettings() {
      return axios.post('/Utility/GetOrganisationSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.spotBillingReceiptLogo = response.data.settings.spotBillingReceiptLogo;
            //console.log(this.spotBillingReceiptLogo)
            return true;
          }
        })
        .catch((e) => { return false });
    },
    updateOnlineStatus(e) {
      const { type } = e;

      this.onLine = type === 'online';

      this.$store.commit('setCsAppsOfflineMode', { status: !this.onLine });
    },
    async getDataForOffline() {
      await this.getReadings();
      await this.getReadingsHistory();
      await this.getConnectionsSpHeaders();

      let cycleId = null;
      await this.$store.state.readingsLocalDB.get(`billingGroups`)
        .then(doc => {
          //console.log("doc", doc)
          //console.log("this.bg", this.bg)
          //console.log("doc.billingGroups.filter(d => this.bg == d.id)", doc.billingGroups.filter(d => this.bg == d.id))
          cycleId = doc.billingGroups.filter(d => this.bg == d.id)[0].cycleId;
        })
        .catch(err => {
          this.$alertMsg(this.$t('captureMR.CycleIdError'));
          this.$router.push('/login');
        });

      this.readings.forEach(r => r['cycleId'] = cycleId);
      //console.log("read", this.readings)
      const data = {
        readings: this.readings,
        readingsHistory: this.readingsHistory,
        connectionSpHeaders: this.connectionSpHeaders
      };

      this.saveDataIntoLocalDb(data);

      //this.$store.commit('setOfflineReadingsData', {
      //  data
      //});
    },
    saveDataIntoLocalDb(data) {      
      this.$store.state.readingsLocalDB.get(`${this.book}_${this.walk}`)
        .then(doc => {
          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            bookId: this.book,
            walkId: this.walk,
            readings: data.readings,
            readingsHistory: data.readingsHistory,
            connectionsSpHeaders: data.connectionSpHeaders
          });

          this.updateBillGroupBooks();
          this.loading = false;
        })
        .catch(err => {
          if (err.status == 404) {
            this.$store.state.readingsLocalDB.put({
              _id: `${this.book}_${this.walk}`,
              bookId: this.book,
              walkId: this.walk,
              readings: data.readings,
              readingsHistory: data.readingsHistory,
              connectionsSpHeaders: data.connectionSpHeaders
            });

            this.updateBillGroupBooks();
            this.loading = false;
          }
        })
    },
    updateBillGroupBooks() {
      this.$store.state.readingsLocalDB.get(`bg_${this.bg}_booksWalks`)
        .then(doc => {

          const booksWalks = doc.booksWalks;

          booksWalks.filter(a => a.bookId == this.book && a.walkId == this.walk)[0].enableOffline = true;

          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            bg: this.bg,
            booksWalks: booksWalks
          });
        });
    },
    getDateFromOfflineDb() {
      this.$store.state.readingsLocalDB.get(`${this.book}_${this.walk}`)
        .then(doc => {
          this.readings = doc.readings;
          this.prepareReadings();
          this.readingsHistory = doc.readingsHistory;
          this.connectionSpHeaders = doc.connectionsSpHeaders;
          this.loading = false;
        })
        .catch(err => {
          this.$alertMsg('No data found for offline mode');
        });
    },
    
    async getReadings() {
      const parameter = {
        BookId: this.book,
        WalkId: this.walk,
        Status1: 1,
        Status2: 2,
        Status3: 3,
        ListOptions: null
      };

      await axios.post('/CaptureMeterReading/GetReadings', parameter)
        .then(response => {
          if (response.status == 200) {
            this.readings = response.data.items;
            if (response.data.data.status != 0) {
              this.$router.push('/employeeHome');
              return;
            }

            this.prepareReadings();

            for (var i = 0; i < response.data.items.length; ++i) {
              response.data.items[i]['averageConsumption'] = null;
              response.data.items[i]['specialCase'] = null;

              response.data.items[i].numbering = i;
              response.data.items[i]['isEdited'] = false;
              response.data.items[i].fullId = response.data.items[i].bookId + '-' + response.data.items[i].walkId + '-' + response.data.items[i].sequence;
              response.data.items[i].consumption = 0;
              response.data.items[i].prRead1 = (response.data.items[i].prRead1 === null) ? 0 : response.data.items[i].prRead1;
              response.data.items[i].curAvrCns = 0;
              response.data.items[i].statusText = response.data.items[i].status === 1 ? 'Unread' : response.data.items[i].status === 2 ? 'Read' : response.data.items[i].status === 3 ? 'Completed' : 'Unknown';
              response.data.items[i].crDate = new Date(response.data.items[i].crDate);
              response.data.items[i].prDate1 = new Date(response.data.items[i].prDate1);

              if ((response.data.items[i].connectionStatus == 0 || response.data.items[i].connectionStatus == 3) && !response.data.items[i].meterRef)
                response.data.items[i].isReadOnly = true;
            }
            this.readings = [];
            this.readings = response.data.items;

            this.prepareReadings();
          }
          else 
            this.$router.push('/employeeHome');
        })
        .catch(e => {
          this.$router.push('/employeeHome');
          return false;
        })
    },
    getClassBillGroups(id) {
      return 'md-primary';
    },
    isDisconnectedDiscrepancyColor(item) {
      if (item.connectionStatus == 2 || item.connectionStatus == 3)
        return 'color: red!important;'
      else if (item.readingDiscrepancyType >= 3 && item.readingDiscrepancyType <= 17)
        return 'color: #FF8C00!important;'
      else
        return '';
    },
    prepareReadings() {
      this.filteredReadings = this.readings;
      this.readingsOptions.total = this.readings;
    },
    async getReadingsHistory() {
      var parameter = {
        BookId: this.book,
        WalkId: this.walk,
      };

      await axios.post('/CaptureMeterReading/GetReadingsHistory', parameter)
        .then(response => {
          if (response.status == 200) {
            this.readingsHistory = response.data.items;
            return true;
          }
        })
        .catch(e => {
          return false;
        });
    },
    async getConnectionsSpHeaders() {
      if (this.readings == null)
        return;

      const connectionIds = [...new Set(this.readings.map(a => a.connectionId))];
      const parameters = {
        ConnectionIds: connectionIds
      }

      await axios.post('/CaptureMeterReading/GetConnectionsSpHeaders', parameters)
        .then(response => {
          this.connectionSpHeaders = response.data;
          return true;
        })
        .catch(e => {
          return false;
        })
    },
    selectReading(item) {
      const bookId = item.bookId.replace(/\//g, '%2F');
      var route;
      if (this.searchEnabled == true)
        route = `/captureMeterReadingsEditReading/${this.bg}/${bookId}/${item.walkId}/${item.sequence}`;
      else
        route = `/captureMeterReadingEditReading/${this.bg}/${bookId}/${item.walkId}/${item.sequence}`;
      this.$router.push(route);
    },
    openMap() {
      const bookId = this.book.replace(/\//g, '%2F');

      var route = `/captureMeterReadingsEditReadingMap/${this.bg}/${bookId}/${this.walk}`;
      this.$router.push(route);
    },
    getBillingGroupName() {
      this.$store.state.readingsLocalDB.get(`billingGroups`)
        .then(doc => {
          this.readingsTitle = doc.billingGroups.filter(a => a.id == this.bg)[0].name;
          this.getBookWalkName();
        })
        .catch(err => {

        });
    },
    getBookWalkName() {
      this.$store.state.readingsLocalDB.get(`bg_${this.bg}_booksWalks`)
        .then(doc => {
          this.readingsTitle += ' / ' + doc.booksWalks.filter(a => a.bookId == this.book && a.walkId == this.walk)[0].name;
          this.key = this.key + 1;

        })
        .catch(err => {

        });
    }
  }
}
